import events from '@layers/web/constants/events.ts'
import { persistMetaClickId, readMetaClickIdFromUrl } from '@layers/web/utils/meta-click-id.ts'

export default defineNuxtPlugin(() => {
  const clickId = readMetaClickIdFromUrl(window.location.search)
  if (!clickId) {
    return
  }

  const persistOnAdvertisingConsent = () => {
    if (!getUserConsentStatus().advertising) {
      return
    }

    window.removeEventListener(events.rbcsChange, persistOnAdvertisingConsent)
    persistMetaClickId(clickId, window.location.hostname)
  }

  window.addEventListener(events.rbcsChange, persistOnAdvertisingConsent)
})
